import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DailyLegLoadsLogPage } from './daily-leg-loads-log';
import { DailyLegLoadsLogComponentPageModule } from '../daily-leg-loads-log-component/daily-leg-loads-log-component.module';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    DailyLegLoadsLogPage,
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(DailyLegLoadsLogPage),
    DailyLegLoadsLogComponentPageModule,
  ],
})
export class DailyLegLoadsLogPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/daily-leg-loads/daily-leg-loads-log/daily-leg-loads-log.module.ts